import { createReducer } from '@reduxjs/toolkit';
import { Nullable } from 'modules/types/common';
import { Profile } from 'store/profile/types';
import {
  switchAccountStart,
  switchAccountFail,
  switchAccountSuccess,
  setSwitchAccountOpen,
  RESET_ACCESS,
  RESET_ACCESS_SUCCESS,
  RESET_ACCESS_FAIL,
  CREATE_MESSAGING_ALIASES,
  CREATE_MESSAGING_ALIASES_SUCCESS,
  CREATE_MESSAGING_ALIASES_FAIL
} from './actions';

/**
 * When an account is being proxied, it is located in proxied Account.
 */
export interface AccountState {
  loading: boolean;
  error: Nullable<Error>;
  proxiedAccount: Nullable<Profile>;
  isAccountSwitcherModalOpen: boolean;
  isAccountResetting: boolean;
  accountResetError: Nullable<Error>;
  isCreatingMessagingAliases: boolean;
  createMessagingAliasesError: Nullable<Error>;
}

export const initialState = {
  loading: false,
  error: null,
  proxiedAccount: null,
  isAccountSwitcherModalOpen: false,
  isAccountResetting: false,
  accountResetError: null,
  createMessagingAliasesError: false,
  isCreatingMessagingAliases: false
};

const accountReducer = createReducer<AccountState>(initialState, {
  [switchAccountStart.type]: state => {
    state.loading = true;
    state.error = null;
  },

  [switchAccountSuccess.type]: (state, action: ReturnType<typeof switchAccountSuccess>) => {
    state.proxiedAccount = action.payload;
    state.loading = false;
  },

  [switchAccountFail.type]: (state, action: ReturnType<typeof switchAccountFail>) => {
    state.loading = false;
    state.error = action.error;
  },

  [setSwitchAccountOpen.type]: (state, action: ReturnType<typeof setSwitchAccountOpen>) => {
    state.loading = false;
    state.isAccountSwitcherModalOpen = action.payload;
  },
  [RESET_ACCESS]: state => {
    state.isAccountResetting = true;
    state.accountResetError = null;
  },
  [RESET_ACCESS_SUCCESS]: state => {
    state.isAccountResetting = false;
  },
  [RESET_ACCESS_FAIL]: (state, action) => {
    state.isAccountResetting = false;
    state.accountResetError = action.error;
  },
  [CREATE_MESSAGING_ALIASES]: state => {
    state.isCreatingMessagingAliases = true;
    state.createMessagingAliasesError = null;
  },
  [CREATE_MESSAGING_ALIASES_SUCCESS]: state => {
    state.isCreatingMessagingAliases = false;
  },
  [CREATE_MESSAGING_ALIASES_FAIL]: (state, action) => {
    state.isCreatingMessagingAliases = false;
    state.createMessagingAliasesError = action.error;
  }
});

export default accountReducer;
